import React from "react";
import {
  formatCitation,
  formatVerseText,
  isLegacyTalkHtml,
  parseTalkWorksheet,
  worksheetHasRules,
  worksheetLineCount,
  worksheetLineCountFromHtml,
} from "../utils/talkWorksheet";

const WritingLines = ({ count }) => {
  if (!count) return null;
  return (
    <div className="talk-worksheet-lines" aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <div className="talk-worksheet-line" key={index}>
          <span>&#8203;</span>
        </div>
      ))}
    </div>
  );
};

const TalkWorksheet = ({
  title,
  speakerName,
  bannerColor = "#1f4e7a",
  content,
  worksheet,
}) => {
  const parsed = worksheet || parseTalkWorksheet(content);
  const legacy = !parsed && isLegacyTalkHtml(content);
  const html = typeof parsed?.html === "string" ? parsed.html : null;
  const verses = parsed?.verses || [];
  const questions = parsed?.questions || [];

  return (
    <div className="talk-worksheet-sheet">
      <div
        className="speakersQuestions talk-worksheet-banner"
        style={{ backgroundColor: bannerColor || "#1f4e7a" }}
      >
        <h3>{title}</h3>
        {speakerName ? <h4>{speakerName}</h4> : null}
      </div>

      {html != null ? (
        <div className="talk-worksheet">
          {html ? (
            <div
              className="talk-worksheet-html"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : null}
          <WritingLines
            count={
              worksheetHasRules(html) ? 0 : worksheetLineCountFromHtml(html)
            }
          />
        </div>
      ) : legacy ? (
        <div className="howerOption talk-question">
          <div
            className="mb-4 roaster_list"
            style={{ textAlign: "left" }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      ) : (
        <div className="talk-worksheet">
          {verses.map((verse) => (
            <div className="talk-worksheet-verse" key={verse.id}>
              <p>{formatVerseText(verse.text)}</p>
              {verse.citation ? (
                <p className="talk-worksheet-citation">
                  {formatCitation(verse.citation)}
                </p>
              ) : null}
            </div>
          ))}

          {questions.length > 0 ? (
            <div className="talk-worksheet-questions">
              {questions.map((question, index) => (
                <p className="talk-worksheet-question" key={question.id}>
                  <span className="talk-worksheet-qnum">{index + 1}.</span>
                  <span className="talk-worksheet-question-text">
                    {question.text}
                  </span>
                </p>
              ))}
            </div>
          ) : null}

          <WritingLines
            count={worksheetLineCount(verses.length, questions.length)}
          />
        </div>
      )}
    </div>
  );
};

export default TalkWorksheet;
